import { render, staticRenderFns } from "./CargoCrudChecklistId.vue?vue&type=template&id=c9489d7c&scoped=true"
import script from "./CargoCrudChecklistId.vue?vue&type=script&lang=js"
export * from "./CargoCrudChecklistId.vue?vue&type=script&lang=js"
import style0 from "./CargoCrudChecklistId.vue?vue&type=style&index=0&id=c9489d7c&prod&lang=css"
import style1 from "./CargoCrudChecklistId.vue?vue&type=style&index=1&id=c9489d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9489d7c",
  null
  
)

export default component.exports